import { TableCell, TableHead, TableRow, withStyles } from "@material-ui/core";
import React from "react";
import { HeadCell } from "../helpers";
import styles from "./styles";

interface Props {
  headCells: HeadCell[];
  classes?: any;
}

function TableHeader(props: Props) {
  const { headCells, classes } = props;

  return (
    <TableHead>
      <TableRow
        classes={{
          root: classes.tableRowHeader,
        }}
      >
        {headCells.map((headCell) => {
          return (
            <TableCell
              key={headCell.id}
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={"asc"}
              data-value={headCell.id}
            >
              <div>{headCell.label}</div>
            </TableCell>
          );
        })}
        <TableCell id={"visualiser"} sortDirection={false}></TableCell>
      </TableRow>
    </TableHead>
  );
}

export default withStyles(styles)(TableHeader);
